<template>
  <el-button size="small" :type="active ? 'primary' : 'default'" @click="$emit('toggle')">
    <el-icon class="list-filter-toggle__icon"><Search /></el-icon>
    查询
  </el-button>
</template>

<script setup>
import { Search } from '@element-plus/icons-vue'

defineProps({
  active: { type: Boolean, default: false },
})

defineEmits(['toggle'])
</script>

<style scoped>
.list-filter-toggle__icon {
  margin-right: 4px;
}
</style>
